import {FormControl} from '@angular/forms';

export class Branch {
    id: string;
    name: string;
    // password: string;
    // email: string;
    // lang: string;
    // branch_id: string;
    status: string;
    telephone: string;
    address: string; 
    fax: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string; 
  usermanager: string;
  storeid: string;
  currencyid: string;
  cityid: string;
  manager_id: string;
  store_id: string;
  currency_id: string;
  city_id: string;
  costcenter_id: string;
  sales_no_tax_acc_code: string;
  sales_tax_acc_code: string;
  discount_acc_code: string;
  sales_return_no_tax_acc_code: string;
  sales_return_tax_acc_code: string;
  payment_no_tax_acc_code: string;
  payment_tax_acc_code: string;
  payment_return_no_tax_acc_code: string;
  payment_return_tax_acc_code: string;
  bank_acc_cash: string;
  bank_acc_transfers: string;
  bank_acc_creditcards: string;
  bank_acc_atmcards: string;
  additional_tax_acc_code: string;
  other_tax_acc_code: string;
  cashier_acc_code: string;
  customers_acc_code: string;
  suppliers_acc_code: string;
  representative_acc_code: string;
  bank_acc_points_and_vouchers: string;
    // manager: any;
    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }

}



// WEBPACK FOOTER //
// ./src/app/views/setting/branches/branch.ts